<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Imprimir Documento
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Facturación masiva</span>
      <span> /</span>
      <span>Imprimir Documento</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body align-items-center">
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaDesde" formControlName="fechaDesde" [placeholder]="'Desde'"
              required></mdb-date-picker>
          </div>
        </div>
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechahasta" formControlName="fechaHasta" [placeholder]="'Hasta'"
              required></mdb-date-picker>
          </div>
        </div>

        <div class="col dato" style="max-width: 150px;">
          <Strong class="title">Camión</Strong>
          <span class="value">{{camion}}</span>
        </div>
        <div class="col dato" style="max-width: 200px;">
          <Strong class="title">Chofer</Strong>
          <span class="value">{{chofer}}</span>
        </div>

        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsRecorrido" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar recorrido" formControlName="listaRecorridos"></mdb-select>
            <label>Recorrido</label>
          </div>
        </div>

        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsComunas" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Todos" formControlName="listaComunas"></mdb-select>
            <label>Comunas</label>
          </div>
        </div>

        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsVendedor" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Todos" formControlName="listaVendedor"></mdb-select>
            <label>Vendedor</label>
          </div>
        </div>
      </div>
      <div class="row filtros-body">
        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="text" id="rutcliente" class="form-control" placeholder="9.999.999-9" #rutcliente
              formControlName="rutCliente" formatRut />
            <label>Rut Cliente</label>
          </div>
        </div>
        <div class="col d-flex" style="max-width: 37%;">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarcliente()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents" *ngIf="cliente">
            {{ cliente.razon_social }}
          </h6>
        </div>

        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="number" id="nroDoc" class="form-control" formControlName="nroDoc"
              placeholder="Nro. de Doc" #nroDoc />
            <label for="nroDoc">Nro. de Documento</label>
          </div>
        </div>

        <div class="col" style="max-width: 250px;">
          <div class="md-form">
            <mdb-select [options]="optionsTipoDoc" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar tipo documento" formControlName="listaTipoDoc"></mdb-select>
            <label>Tipo documento</label>
          </div>
        </div>


      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div class="resultados pl-2">
        <button *ngIf="visualizarLimpiadorImp" mdbBtn type="button"
          [ngStyle]="{'background-color': '#ffcc00', 'color': '#000'}" size="sm" mdbWavesEffect
          (click)="limpiarImpresionTablasLsof()" [disabled]="loadSpinner">
          <div *ngIf="loadSpinner" class="spinner-border spinner-border-sm" style="margin-right: 5px;" role="status">
          </div>
          Limpiar Impresiones
        </button>
      </div>
      <div class="d-flex justify-content-end"> <!-- Alinea los botones a la derecha -->
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="LimpiarData()">
          Limpiar
        </button>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
          <mdb-icon fas icon="search"></mdb-icon>
          Buscar
        </button>
      </div>
    </div>
  </div>

  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="table-responsive">
        <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">
                <mdb-checkbox [checked]="true" (change)="checkAllChange($event)"></mdb-checkbox>
              </th>
              <th scope="col">Documento</th>
              <th scope="col">Folio</th>
              <th scope="col">Fecha</th>
              <th scope="col">Rut</th>
              <th scope="col">Cliente</th>
              <th scope="col">Monto total</th>
              <th scope="col">Vendedor</th>
              <th scope="col">Comuna</th>
              <th scope="col">Sec.</th>
              <th scope="col">Ruta</th>
              <th scope="col">Rec.</th>
              <th scope="col"></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="100%" style="text-align: center" *ngIf="loading">
                <mdb-spinner spinnerColor="blue"></mdb-spinner>
              </td>
              <td colspan="100%" style="text-align: center" *ngIf="!loading && listaMovimientos?.length === 0">
                No se encontró información
              </td>
            </tr>
            <tr *ngFor="let mov of listaMovimientos">
              <td>
                <mdb-checkbox [checked]="mov.additionalInfo.checked" (change)='checkDetalle(mov.additionalInfo)'>
                </mdb-checkbox>
              </td>
              <td *ngIf="mov.impresion_doc" class="blue-text">{{ mov.tipo_dte_nombre }}</td>
              <td *ngIf="!mov.impresion_doc" class="black-text">{{ mov.tipo_dte_nombre }}</td>
              <td *ngIf="mov.impresion_doc" class="blue-text">{{ mov.folio }}</td>
              <td *ngIf="!mov.impresion_doc" class="black-text">{{ mov.folio }}</td>
              <td *ngIf="mov.impresion_doc" class="blue-text">{{ mov.fecha_emision | fecha}}</td>
              <td *ngIf="!mov.impresion_doc" class="black-text">{{ mov.fecha_emision | fecha}}</td>
              <td *ngIf="mov.impresion_doc" class="blue-text">{{ mov.rutFormato | rut }}</td>
              <td *ngIf="!mov.impresion_doc" class="black-text">{{ mov.rutFormato | rut }}</td>
              <td *ngIf="mov.impresion_doc" class="blue-text">{{ mov.cliente_nombre }}</td>
              <td *ngIf="!mov.impresion_doc" class="black-text">{{ mov.cliente_nombre }}</td>
              <td *ngIf="mov.impresion_doc" class="blue-text">{{ mov.monto_total | numerico }}</td>
              <td *ngIf="!mov.impresion_doc" class="black-text">{{ mov.monto_total | numerico }}</td>
              <td *ngIf="mov.impresion_doc" class="blue-text">{{ mov.vendedor_nombre }}</td>
              <td *ngIf="!mov.impresion_doc" class="black-text">{{ mov.vendedor_nombre }}</td>
              <td *ngIf="mov.impresion_doc" class="blue-text">{{ mov.comuna_facturacion }}</td>
              <td *ngIf="!mov.impresion_doc" class="black-text">{{ mov.comuna_facturacion }}</td>
              <td *ngIf="mov.impresion_doc" class="blue-text">{{ mov.secuencia }}</td>
              <td *ngIf="!mov.impresion_doc" class="black-text">{{ mov.secuencia }}</td>
              <td *ngIf="mov.impresion_doc" class="blue-text">{{ mov.ruta_codigo }}</td>
              <td *ngIf="!mov.impresion_doc" class="black-text">{{ mov.ruta_codigo }}</td>
              <td *ngIf="mov.impresion_doc" class="blue-text">{{ mov.recorrido_codigo }}</td>
              <td *ngIf="!mov.impresion_doc" class="black-text">{{ mov.recorrido_codigo }}</td>
              <td>
                <!-- <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm">
                <mdb-icon far icon="file-pdf" (click)="downloadPdf()" mdbTooltip="Descagar PDF" placement="right"></mdb-icon>
              </button> -->
                <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                  (click)="showImprimirFacturaDetalle(mov)" mdbTooltip="Ver" placement="right">
                  <mdb-icon fas icon="eye"></mdb-icon>
                </button>
                <ng-container *ngIf="!mov.loadingPdf">
                  <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                    (click)="downloadExcelPdf(mov)" mdbTooltip="Descagar PDF" placement="right">
                    <mdb-icon fas icon="file-pdf"></mdb-icon>
                  </button>
                </ng-container>
                <ng-container *ngIf="mov.loadingPdf">
                  <mdb-spinner spinnerColor="blue" spinnerType="small"></mdb-spinner>
                </ng-container>
              </td>
            </tr>
          </tbody>
          <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
            *ngIf="listaMovimientos?.length > 0"></app-pagination>
        </table>
      </div>

      <div class="row" *ngIf="listaMovimientosAll?.length > 0">
        <div class="col" style="max-width: 200px;">
          <Strong class="title">Nro. Documentos : </Strong>
          <span class="value">{{docSeleccionado}}</span>
        </div>
        <div class="col">
          <!-- Material inline 1 -->
          <mdb-checkbox formControlName="documento" [inline]="true">Documento</mdb-checkbox>
          <!-- Material inline 2 -->
          <mdb-checkbox formControlName="copia_cedible" [inline]="true">Copia Cedible</mdb-checkbox>
          <!-- Material inline 3 -->
          <mdb-checkbox formControlName="enviar_pdf" [inline]="true">Enviar PDF</mdb-checkbox>
          <!-- Material inline 3 -->
          <mdb-checkbox formControlName="enviar_xml" [inline]="true">Enviar XML</mdb-checkbox>
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-2 wow" *ngIf="listaMovimientosAll?.length > 0">
    <div class="card-body d-sm-flex p-1 justify-content-end">
      <div class="md-form" style="min-width: 200px;">
        <mdb-select formControlName="orden_envio" [options]="optionsOrderImpresion" [filterEnabled]="true"
          [highlightFirst]="false" placeholder="Seleccionar orden">
        </mdb-select>
        <label>Orden de impresión</label>
      </div>
      <app-api-button (click2)="enviarDocumentos()" [processing]="processing">
        Enviar selección
      </app-api-button>
    </div>
  </div>
</form>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT" (onSelectSingle)="onClienteSeleccionado($event)"
  (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>
<!--Detalle Documento-->
<app-modal-imprimir-factura-detalle></app-modal-imprimir-factura-detalle>
<!--Resultado Envio-->
<app-modal-imprimir-factura-resultado></app-modal-imprimir-factura-resultado>